/**
 * QuantityStrip — Sprint R1
 *
 * Horizontal 0–N tap-a-number quantity selector. Replaces +/- steppers in
 * the buyer ticket panel. For reserved seating the chosen quantity is how
 * many seats the buyer must select; for GA it directly sets ticket count.
 */
import React from "react";

export default function QuantityStrip({
  value = 0,
  max = 0,
  onChange,
  label = "Ticket quantity",
  testId = "qty-strip",
}) {
  if (max <= 0) return null;
  const nums = Array.from({ length: max + 1 }, (_, i) => i);
  return (
    <div
      className="-mx-1 overflow-x-auto pb-1"
      role="radiogroup"
      aria-label={label}
      data-testid={testId}
    >
      <div className="flex gap-1 px-1 min-w-max">
        {nums.map((n) => {
          const active = value === n;
          return (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={active}
              aria-label={`${n} tickets`}
              onClick={() => onChange?.(n)}
              data-testid={`${testId}-btn-${n}`}
              className={
                "w-8 h-8 shrink-0 rounded-sm border font-mono text-xs font-bold transition-colors " +
                (active
                  ? "bg-[var(--gt-ink)] text-white border-[var(--gt-ink)]"
                  : "bg-white border-[var(--gt-line)] hover:border-[var(--gt-ink)] hover:bg-[var(--gt-bg-surface)]")
              }
            >
              {n}
            </button>
          );
        })}
      </div>
    </div>
  );
}
